import { SharedUser } from '../models/user';

type SortableUser = SharedUser;

export function sortUserList<T extends SortableUser>(users: T[]): T[] {
  return users.toSorted((a, b) => {
    // Own user always pinned to the top
    if (a.isSelf && !b.isSelf) {
      return -1;
    }
    if (!a.isSelf && b.isSelf) {
      return 1;
    }
    if (a.isFavorite && !b.isFavorite) {
      return -1;
    }
    if (!a.isFavorite && b.isFavorite) {
      return 1;
    }
    // Users with a raised hand sort above everyone else (except own user / favorites)
    if (a.data.hasRaisedHand && !b.data.hasRaisedHand) {
      return -1;
    }
    if (!a.data.hasRaisedHand && b.data.hasRaisedHand) {
      return 1;
    }
    if (a.data.status === 'online' && b.data.status === 'away') {
      return -1;
    }
    if (a.data.status === 'away' && b.data.status === 'online') {
      return 1;
    }

    if (a.data.outputMuted < b.data.outputMuted) {
      return -1;
    }
    if (a.data.outputMuted > b.data.outputMuted) {
      return 1;
    }

    // Match the avatar's mute indicator: a remote user without audio is
    // also muted, even if their advertised inputMuted flag is still false.
    const inputMutedA = a.data.inputMuted || (!a.isSelf && !a.audioOutput);
    const inputMutedB = b.data.inputMuted || (!b.isSelf && !b.audioOutput);
    if (inputMutedA !== inputMutedB) {
      return inputMutedA ? 1 : -1;
    }

    if (a.data.name.toLowerCase() < b.data.name.toLowerCase()) {
      return -1;
    }
    if (a.data.name.toLowerCase() > b.data.name.toLowerCase()) {
      return 1;
    }
    return 0;
  });
}
